module.exports = __webpack_public_path__ + "img/MEDIA063.c509a21b.jpg";